import type { FormDatePickerProps } from '../types';
import type { FieldValues } from 'react-hook-form';

import { DatePicker } from '@/components/DatePicker';

import { DISPLAY_DATES_FORMAT, SEND_DATES_FORMAT } from '@/constants/dates';

import { FormFieldShell } from '../FormFieldShell';

export const FormDatePicker = <TFieldValues extends FieldValues = FieldValues>(
  props: FormDatePickerProps<TFieldValues>,
) => {
  const {
    name,
    label,
    hint,
    placeholder,
    description,
    isRequired,
    dateFormat = SEND_DATES_FORMAT,
    displayDateFormat = DISPLAY_DATES_FORMAT,
    showYearDropdown = true,
  } = props;

  return (
    <FormFieldShell
      name={name}
      description={description}
      render={({ field, fieldState, fieldId }) => (
        <DatePicker
          showYearDropdown={showYearDropdown}
          id={fieldId}
          value={field.value || ''}
          onChange={field.onChange}
          label={label}
          aria-label={label}
          isRequired={isRequired}
          hint={hint}
          placeholder={placeholder ?? label}
          dateFormat={dateFormat}
          displayDateFormat={displayDateFormat}
          aria-invalid={fieldState.invalid}
        />
      )}
    />
  );
};
